import { render, staticRenderFns } from "./AutomationTemplatesSellsy.vue?vue&type=template&id=213ef862&scoped=true&"
import script from "./AutomationTemplatesSellsy.vue?vue&type=script&lang=js&"
export * from "./AutomationTemplatesSellsy.vue?vue&type=script&lang=js&"
import style0 from "./AutomationTemplatesSellsy.vue?vue&type=style&index=0&id=213ef862&prod&lang=scss&scoped=true&"
import style1 from "./AutomationTemplatesSellsy.vue?vue&type=style&index=1&id=213ef862&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213ef862",
  null
  
)

export default component.exports